import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BellRing, X } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuCard } from "../neu/Neu";
import { enableWebPush, webPushState } from "../../native/webPush";
import { useAuth } from "../../context/AuthContext";
import { IS_STORE_BUILD } from "../../config/storeBuild";

const KEY = "push_banner_dismissed";

// شريط ظاهر لمن لم يفعّل إشعارات الجهاز بعد — بضغطة واحدة تظهر الإشعارات على شاشة القفل.
export const PushEnableBanner = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [state, setState] = useState(webPushState());
  const [hidden, setHidden] = useState(localStorage.getItem(KEY) === "1");
  const [busy, setBusy] = useState(false);

  const enable = async () => {
    setBusy(true);
    try {
      const res = await enableWebPush();
      setState(res.enabled ? "granted" : webPushState());
      toast[res.enabled ? "success" : "error"](t(res.enabled ? "push.enabled" : `push.${res.reason}`));
    } catch {
      toast.error(t("errors.generic"));
    }
    setBusy(false);
  };

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setHidden(true);
  };

  if (!user || hidden || IS_STORE_BUILD || !["default", "ios_install"].includes(state)) return null;
  return (
    <NeuCard className="mb-5 flex flex-wrap items-center justify-between gap-3 p-4" data-testid="push-enable-banner">
      <div className="flex min-w-0 items-center gap-3">
        <BellRing className="h-4 w-4 shrink-0 text-primary" />
        <div className="min-w-0">
          <p className="text-sm font-black">{t("push.bannerTitle")}</p>
          <p className="text-xs text-muted-foreground">
            {t(state === "ios_install" ? "push.iosHint" : "push.bannerBody")}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {state === "default" ? (
          <NeuButton variant="primary" disabled={busy} data-testid="push-banner-enable-btn"
                     className="px-4 py-2 text-xs" onClick={enable}>
            {t("push.enable")}
          </NeuButton>
        ) : null}
        <button type="button" data-testid="push-banner-dismiss" onClick={dismiss} className="rounded-full p-2 shadow-neu-sm">
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </NeuCard>
  );
};
